import * as version0_1Rules from './0.1/index'
import * as version10_0Rules from './10.0/index'
import * as version11_0Rules from './11.0/index'
import * as version12_0Rules from './12.0/index'
import * as version13_0Rules from './13.0/index'
import * as version_14_08Rules from './14.08/index'
import * as version14_10Rules from './14.10/index'
import * as version14_12Rules from './14.12/index'
import * as version15_02Rules from './15.02/index'
import * as version15_06Rules from './15.06/index'
import * as version15_10Rules from './15.10/index'

export type UpgradeFunction = (pcr: any, ...elements: string[]) => any
export const versionToUpgradeFunctions: Map<string, UpgradeFunction[]> = new Map<string, UpgradeFunction[]>()

// Any new version folders added should be added to this map
versionToUpgradeFunctions.set('0.1', Object.values(version0_1Rules))
versionToUpgradeFunctions.set('10.0', Object.values(version10_0Rules))
versionToUpgradeFunctions.set('11.0', Object.values(version11_0Rules))
versionToUpgradeFunctions.set('12.0', Object.values(version12_0Rules))
versionToUpgradeFunctions.set('13.0', Object.values(version13_0Rules))
versionToUpgradeFunctions.set('14.08', Object.values(version_14_08Rules))
versionToUpgradeFunctions.set('14.10', Object.values(version14_10Rules))
versionToUpgradeFunctions.set('14.12', Object.values(version14_12Rules))
versionToUpgradeFunctions.set('15.02', Object.values(version15_02Rules))
versionToUpgradeFunctions.set('15.06', Object.values(version15_06Rules))
versionToUpgradeFunctions.set('15.10', Object.values(version15_10Rules))

// Access to the upgrade functions for a given version
export const getUpgrades = (version: string): UpgradeFunction[] | undefined => {
  return versionToUpgradeFunctions.get(version)
}
